import React from 'react';
import T from 'prop-types';

import skeletons from '../../Skeletons';
import Tooltip from '../../../../../Tooltip';
import SimpleCard from '../../../../../Card/SimpleCard';
import ThresholdBadge from '../../../../../ThresholdBadge';

const normalizeValue = (_value) => {
  const value = _value?.toLowerCase() || '';
  const formattedValue = `${value} Consensus`;
  if (value === 'above consensus' || value === 'rising' || value.includes('above'))
    return { aboveLabel: formattedValue, value: 1 };
  if (
    value === 'inline with consensus' ||
    value.includes('inline') ||
    value === 'inline consensus' ||
    value.includes('stable') ||
    value === 'no clear trend'
  )
    return { inlineLabel: 'Inline w/Consensus', value: 0 };
  if (value === 'below consensus' || value === 'below' || value.includes('declining'))
    return { belowLabel: formattedValue, value: -1 };
  return {};
};
const MpiSpotlightQV = ({ kpiSpotlight, settings }) => (
  <SimpleCard
    className="kpi-spotlight-qv mpi-spotlight-qv"
    headerLeft={
      settings.pending ? (
        skeletons.kpiSpotlight.cardTitle
      ) : (
        <h4 className="h4">Mobile Performance Index</h4>
      )
    }
  >
    {settings.pending ? (
      skeletons.kpiSpotlight.cardBody
    ) : (
      <>
        <div className="kpi-forecasts-qv__trow">
          <div className="kpi-forecasts-qv__thcell">Company KPI</div>
          <div className="kpi-forecasts-qv__thcell text-center">MPI Momentum</div>
          <div className="kpi-forecasts-qv__thcell text-center">MPI 90d Trend</div>
        </div>
        {kpiSpotlight.map((item, i) => (
          <div key={i} className="kpi-forecasts-qv__trow">
            <div className="kpi-forecasts-qv__tdcell">
              <Tooltip content={item.va_kpi_name}>
                <p className="text-truncate">{item.va_kpi_name}</p>
              </Tooltip>
            </div>
            <div className="kpi-forecasts-qv__tdcell">
              <ThresholdBadge displayMode="label" {...normalizeValue(item.read)} />
            </div>
            <div className="kpi-forecasts-qv__tdcell">
              <p className="text-normal">{item.trend?.replace(/trend/i, '')}</p>
            </div>
          </div>
        ))}
      </>
    )}
  </SimpleCard>
);

MpiSpotlightQV.propTypes = {
  kpiSpotlight: T.array,
  settings: T.object.isRequired,
};

export default MpiSpotlightQV;
